import styled from 'styled-components'
import { taskStatusLabel } from 'features/taskManagement/taskStatusConstants'
import StagePill from './StagePill'
import { formatDay } from './remedialDates'
import { personLabel } from './ownerDisplay'
import { MUTED } from './ui'

const nextTaskText = next => {
  if (!next) return undefined
  const people = (next.assignees || []).map(personLabel).filter(Boolean)
  return [
    `Next task: ${taskStatusLabel(next.status)}`,
    people.length ? people.join(', ') : null,
    next.deadline ? `by ${formatDay(next.deadline)}` : null,
  ].filter(Boolean).join(', ')
}

const TaskProgress = ({ action }) => {
  const summary = action.taskSummary || { count: 0, completed: 0, next: null }
  return (
    <Stack title={nextTaskText(summary.next)}>
      <StagePill stage={action.stage} action={action} size='sm' />
      {summary.count > 0 && (
        <Done title={`${summary.completed} of ${summary.count} task${summary.count === 1 ? '' : 's'} done`}>
          {summary.completed}/{summary.count} done
        </Done>
      )}
    </Stack>
  )
}

export default TaskProgress

const Stack = styled.span`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  min-width: 0;
`

const Done = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${MUTED};
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`
